import { io } from "socket.io-client";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://localhost:4000';

let socket = null;


export const connectToSocket = () => {
    if (!socket || !socket.connected) {
        socket = io(BASE_URL, {
            transports: ['websocket'],
            secure: BASE_URL,
        });

        socket.on('connect', () => {
            console.log("✅ Connected to socket:", socket.id);
        });

        socket.on('disconnect', () => {
            console.log("❌ Socket disconnected");
        });
    }
};

export const onSocketEvent = (eventName, callback) => {
    if (socket) {
        socket.on(eventName, callback);
    }
};

export const emitSocketEvent = (eventName, data) => {
    if (socket) {
        socket.emit(eventName, data);
    }
};

export const disconnectSocket = () => {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
};
